export default "__VITE_ASSET__nOpYm4Lc__"